import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: '#192542',
    padding: theme.spacing(2),
    textTransform: 'uppercase',
    fontSize: '1.1rem',
    fontWeight: 500,
    '& > a': {
      color: 'inherit',
      display: 'block',
    },
    '&:first-child': {
      borderBottom: '1px solid #eadada99',
    },
  },
}));
